var Comment = function() {
	$(".comment-reply-link").on("click", function(e){
		e.preventDefault();
		$(this).parent().next().find("> .comment-reply-form-holder").show();
	});

	$(".comments-holder-container form").on("submit", function(e){
		e.preventDefault();

		var form = $(this);

		$.ajax({
			url: form.prop("action"),
			type: "POST",
			data: form.serialize(),
			success: function(){
				form.replaceWith("<div class='await-moderation'>Tack, din kommentar publiceras inom kort</div>");
			}
		});
	});
};

module.exports = Comment;
